import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/Subscription_Type.css";
import Slider from "react-slick";

const Subscription_Type = () => {
	const settings = {
		className: "center",
		centerMode: true,
		infinite: true,
		centerPadding: "0px",
		slidesToShow: 3,
		speed: 500,
		dots: true,
	};
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* Subsccription type starts here */}
			<section className="subscription">
				<div className="container">
					<div className="row">
						<div className="col-lg-3"></div>
						<div className="col-lg-6">
							<div className="heading-wrapper">
								<h4>Select Subscription Type</h4>
								<p>
									Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
									diam nonumy aliquyam erat
								</p>
							</div>
						</div>
						<div className="col-lg-3"></div>
					</div>
					<div className="subscription-slider row pt-5">
						<Slider {...settings}>
							<div className="col-lg-4">
								<div className="subscription-card-wrapper">
									<div className="heading-wrapper">
										<h6>Per Products</h6>
									</div>
									<div className="heading-list-wrapper">
										<div className="heading-list">
											<h2>15% Per Product</h2>
											<h6>Lorem ipsum dolor sit amet, </h6>
										</div>
										<div className="list-wrapper">
											<ul>
												<li>Lorem ipsum dolor sit amet, </li>
												<li>consectetuer adipiscing elit.</li>
												<li>Aliquam tincidunt mauris eu risus.</li>
												<li>Vestibulum auctor dapibus neque.</li>
												<li>Nunc dignissim risus id metus</li>
												<li>Cras ornare tristique elit.</li>
												<li>Vivamus vestibulum ntulla nec ante.</li>
												<li>Praesent placerat risus quis eros.</li>
											</ul>
										</div>
									</div>
									<div className="btn-wrapper">
										<a href="/Subscription_payment" className="btn">
											Select
										</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4">
								<div className="subscription-card-wrapper">
									<div className="heading-wrapper">
										<h6>Weekly</h6>
									</div>
									<div className="heading-list-wrapper">
										<div className="heading-list">
											<h2>$20 Per Week</h2>
											<h6>Lorem ipsum dolor sit amet, </h6>
										</div>
										<div className="list-wrapper">
											<ul>
												<li>Lorem ipsum dolor sit amet, consectetuer </li>
												<li>adipiscing elit.</li>
												<li>Aliquam tincidunt mauris eu risus.</li>
												<li>Vestibulum auctor dapibus neque.</li>
												<li>Nunc dignissim risus id metus</li>
												<li>Cras ornare tristique elit.</li>
												<li>Vivamus vestibulum ntulla nec ante.</li>
												<li>Praesent placerat risus quis eros.</li>
											</ul>
										</div>
									</div>
									<div className="btn-wrapper">
										<a href="/Subscription_payment" className="btn">
											Selected
										</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4">
								<div className="subscription-card-wrapper">
									<div className="heading-wrapper">
										<h6>Monthly</h6>
									</div>
									<div className="heading-list-wrapper">
										<div className="heading-list">
											<h2>$75 per Month</h2>
											<h6>Lorem ipsum dolor sit amet, </h6>
										</div>
										<div className="list-wrapper">
											<ul>
												<li>Lorem ipsum dolor sit amet, consectetuer </li>
												<li>adipiscing elit.</li>
												<li>Aliquam tincidunt mauris eu risus.</li>
												<li>Vestibulum auctor dapibus neque.</li>
												<li>Nunc dignissim risus id metus</li>
												<li>Cras ornare tristique elit.</li>
												<li>Vivamus vestibulum ntulla nec ante.</li>
												<li>Praesent placerat risus quis eros.</li>
											</ul>
										</div>
									</div>
									<div className="btn-wrapper">
										<a href="/Subscription_payment" className="btn">
											Select
										</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4">
								<div className="subscription-card-wrapper">
									<div className="heading-wrapper">
										<h6>Per Products</h6>
									</div>
									<div className="heading-list-wrapper">
										<div className="heading-list">
											<h2>15% Per Product</h2>
											<h6>Lorem ipsum dolor sit amet, </h6>
										</div>
										<div className="list-wrapper">
											<ul>
												<li>Lorem ipsum dolor sit amet, </li>
												<li>consectetuer adipiscing elit.</li>
												<li>Aliquam tincidunt mauris eu risus.</li>
												<li>Vestibulum auctor dapibus neque.</li>
												<li>Nunc dignissim risus id metus</li>
												<li>Cras ornare tristique elit.</li>
												<li>Vivamus vestibulum ntulla nec ante.</li>
												<li>Praesent placerat risus quis eros.</li>
											</ul>
										</div>
									</div>
									<div className="btn-wrapper">
										<a href="/Subscription_payment" className="btn">
											Select
										</a>
									</div>
								</div>
							</div>
						</Slider>
					</div>
					<div className="row">
						<div className="col-lg-3"></div>
						<div className="col-lg-6">
							<div className="skip-wrapper">
								<a href="/seller-dashboard" className="skip">
									Skip the purchase the subscription plan{" "}
								</a>
							</div>
						</div>
						<div className="col-lg-3"></div>
					</div>
				</div>
			</section>
			{/* Subsccription type ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Subscription_Type;
